import { DeviceEventHit } from '@eppendorf/vnls-device-service-utils';
import { Event as DeviceEvent } from '@eppendorf/vnls-notifications-utils';
import { Badge, Icon, IconSizeClasses } from '@eppendorf/vnls-react-components';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';

import { getDeviceEventCategoryLabel } from '$shared/i18n/device-event-category-label';

import { FeatureIsEnabled } from '$components/feature-toogle/feature-is-enabled';
import { EventDateTimeCell } from '$features/monitoring/events/components/event-date-time-cell';
import { getEventIconName } from '$features/monitoring/events/events.utils';

import styles from './event-row.module.scss';

const TAG_LABELS: Record<string, string> = {
  error: 'Error',
  warn: 'Warn',
  warning: 'Warning',
  notice: 'Notice',
  info: 'Info',
  alert: 'Alert',
};

export function EventRow({ deviceEvent }: { deviceEvent: DeviceEvent | DeviceEventHit }) {
  const { t } = useTranslation();
  const categoryKeys = 'categories' in deviceEvent ? deviceEvent.categories : [];
  return (
    <div className={cn(styles.eventRow, 'event_row')}>
      {/* class .event_row needed for e2e tests */}
      {deviceEvent.tags
        .filter((tag) => tag in TAG_LABELS)
        .map((tag) => (
          <div className={styles.eventRowState} key={`tag-${tag.toLowerCase()}`}>
            <Icon
              name={`event-${getEventIconName(tag.toLowerCase())}`}
              size={IconSizeClasses.XSmall}
              // eslint-disable-next-line security/detect-object-injection -- tags are already filtered
              alt={TAG_LABELS[tag]}
            />
            <span className={styles.eventRowIconLabel}>
              {/* eslint-disable-next-line security/detect-object-injection -- tags are already filtered */}
              {TAG_LABELS[tag]}
            </span>
          </div>
        ))}
      <div className={styles.eventRowTimestamp}>
        <EventDateTimeCell timestamp={deviceEvent.timestamp} />
      </div>
      <div className={styles.eventRowMessage}>
        {deviceEvent.message}
        <FeatureIsEnabled feature="ESEVNLS_4552_DEVICE_EVENT_CATEGORIES">
          <div className={cn(styles.eventRowCategory)}>
            {categoryKeys.length > 0 &&
              categoryKeys.map((categoryKey) => (
                <Badge size="small" key={categoryKey}>
                  {getDeviceEventCategoryLabel(categoryKey, t)}
                </Badge>
              ))}
          </div>
        </FeatureIsEnabled>
      </div>
    </div>
  );
}
